import React from "react";

import styles from "./replace-blueprint-gradient-box.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";

import arrowBlueIcon from "@src/assets/svg/arrow-blue.svg";
import currentBlueprintIcon from "@src/assets/svg/current-blueprint-icon.svg";
import selectedBlueprintIcon from "@src/assets/svg/selected-blueprint-icon.svg";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { ReplaceBlueprintGradientBoxDescriptionContainer } from "@src/components/molecules/replace-blueprint-gradient-box-description-container/replace-blueprint-gradient-box-description-container";
import { ReplaceBlueprintGradientBoxInfoContainer } from "@src/components/molecules/replace-blueprint-gradient-box-info-container/replace-blueprint-gradient-box-info-container";
import { useI18N } from "@src/language/language-context";
const cssClassName = "replace-blueprint-gradient-box";

interface ReplaceBlueprintGradientBoxPropTypes {
  currentBlueprint: BlueprintsArrayObjectTypes;
  selectedBlueprint: BlueprintsArrayObjectTypes;
}

export const ReplaceBlueprintGradientBox = ({
  currentBlueprint,
  selectedBlueprint,
}: ReplaceBlueprintGradientBoxPropTypes) => {
  const i18n = useI18N();

  const texts = {
    arrowBlueIconAltText: i18n(
      "modules.replaceBlueprintGradientBox.arrowBlueIconAltText",
    ),
  };
  return (
    <div className={styles[cssClassName]}>
      <FlexColumnContainer>
        <ReplaceBlueprintGradientBoxInfoContainer
          isCurrentOrSelected="current"
          icon={currentBlueprintIcon}
          blueprint={currentBlueprint}
        />
        {currentBlueprint.description && (
          <ReplaceBlueprintGradientBoxDescriptionContainer
            isCurrentOrSelected="current"
            blueprint={currentBlueprint}
          />
        )}
      </FlexColumnContainer>
      <div className={styles[`${cssClassName}__arrow-wrapper`]}>
        <img src={arrowBlueIcon} alt={texts.arrowBlueIconAltText} />
      </div>
      <FlexColumnContainer>
        <ReplaceBlueprintGradientBoxInfoContainer
          isCurrentOrSelected="selected"
          icon={selectedBlueprintIcon}
          blueprint={selectedBlueprint}
        />
        {selectedBlueprint.description && (
          <ReplaceBlueprintGradientBoxDescriptionContainer
            isCurrentOrSelected="selected"
            blueprint={selectedBlueprint}
          />
        )}
      </FlexColumnContainer>
    </div>
  );
};
